<template>
	<v-container 
			class="customVContainer"
			:style="$_signUp_stylePageContainerStyle()"
			fluid>
		<template v-if="initialized_">
			<v-row	class="customVRow" 
					align="center" 
					justify="center">
				<v-col cols="10" sm="8" md="6">
					<v-card color="transparent" flat>
						<v-card-title>
							<v-row class="my-2" justify="center">
								<v-col cols="auto">
									<span class="h5">Sign Up</span>
								</v-col>
							</v-row>
						</v-card-title>
						<template v-if="!isFalse(errorMessage_)">
							<v-card-text class="cardText_">
								<span class="errorMessage_" v-html="errorMessage_" />
							</v-card-text>
						</template>
						<!-- select sign up option -->
						<template v-if="isEmpty(signUpOption_)">
							<v-card-text class="cardText_">
								<v-select
										v-model="signUpOption_"
										
										hide-details

										:background-color="$_signUp_styleSelectBackgroundColor"
										:chips="$_signUp_styleSelectChips"
										:clearable="$_signUp_styleSelectClearable"
										:color="$_signUp_styleSelectColor"
										:deletable-chips="$_signUp_styleSelectDeletableChips"
										:dark="$_signUp_styleSelectDark"
										:dense="$_signUp_styleSelectDense"
										:filled="$_signUp_styleSelectFilled"
										:flat="$_signUp_styleSelectFlat"
										:light="$_signUp_styleSelectLight"
										:outlined="$_signUp_styleSelectOutlined"
										:small-chips="$_signUp_styleSelectSmallChips"
										:solo="$_signUp_styleSelectSolo"
										:solo-inverted="$_signUp_styleSelectSoloInverted"

										:placeholder="$_signUp_langSelectSignUpOptionPlaceholder"

										:label="$_signUp_langSelectSignUpOption"

										item-text="title"
										item-value="key"
										:items="arrayObject(sortObject($_signUp_contentAppSignUpOptions, 'order'))" />
							</v-card-text>
							<v-card-actions class="center">
								<v-row class="mb-4" dense justify="center">
									<v-col cols="auto">
										<v-btn	class="customVBtn"
												:block="$_signUp_styleLoginButtonBlock"
												:color="$_signUp_styleLoginButtonColor"
												:dark="$_signUp_styleLoginButtonDark"
												:depressed="$_signUp_styleLoginButtonDepressed"
												:elevation="$_signUp_styleLoginButtonElevation"
												:large="$_signUp_styleLoginButtonLarge"
												:light="$_signUp_styleLoginButtonLight"
												:outlined="$_signUp_styleLoginButtonOutlined"
												:rounded="$_signUp_styleLoginButtonRounded"
												:small="$_signUp_styleLoginButtonSmall"
												:text="$_signUp_styleLoginButtonFlat"
												to="/login">
											<span class="overline" v-text="$_signUp_langLoginButton" />
										</v-btn>
									</v-col>
								</v-row>
							</v-card-actions>
						</template>
						<!-- input field -->
						<template v-else>
							<template v-if="mode_.signUp">
								<validation-observer v-slot="validationInput">
									<v-form>
										<v-card-text class="cardText_">
											<template v-if="signUpOption_ == 'email'">
												<validation-provider
														name="Email"
														rules="required|email"
														mode="lazy"
														v-slot="{ errors }">
													<v-text-field
															v-model="form_.email"

															hide-details

															:background-color="$_signUp_styleTextFieldBackgroundColor"
															:clearable="$_signUp_styleTextFieldClearable"
															:color="$_signUp_styleTextFieldColor"
															:counter="$_signUp_styleTextFieldCounter"
															:dark="$_signUp_styleTextFieldDark"
															:filled="$_signUp_styleTextFieldFilled"
															:flat="$_signUp_styleTextFieldFlat"
															:light="$_signUp_styleTextFieldLight"
															:outlined="$_signUp_styleTextFieldOutlined"
															:solo="$_signUp_styleTextFieldSolo"
															:solo-inverted="$_signUp_styleTextFieldSoloInverted"

															:hint="$_signUp_langEmailHint"
															:mask="$_signUp_langEmailMask"
															:message="$_signUp_langEmailMessage"
															:placeholder="$_signUp_langEmailPlaceholder"
															:prefix="$_signUp_langEmailPrefix"
															:suffix="$_signUp_langEmailSuffix"
															:type="$_signUp_langEmailType"

															:label="$_signUp_langEmail"

															:error-messages="errors" />
												</validation-provider>
											</template>
											<template v-if="signUpOption_ == 'phone'">
												<validation-provider
														name="Phone"
														rules="required|phone"
														mode="lazy"
														v-slot="{ errors }">
													<v-text-field
															v-model="form_.phone"

															hide-details

															:background-color="$_signUp_styleTextFieldBackgroundColor"
															:clearable="$_signUp_styleTextFieldClearable"
															:color="$_signUp_styleTextFieldColor"
															:counter="$_signUp_styleTextFieldCounter"
															:dark="$_signUp_styleTextFieldDark"
															:filled="$_signUp_styleTextFieldFilled"
															:flat="$_signUp_styleTextFieldFlat"
															:light="$_signUp_styleTextFieldLight"
															:outlined="$_signUp_styleTextFieldOutlined"
															:solo="$_signUp_styleTextFieldSolo"
															:solo-inverted="$_signUp_styleTextFieldSoloInverted"

															:hint="$_signUp_langPhoneHint"
															:mask="$_signUp_langPhoneMask"
															:message="$_signUp_langPhoneMessage"
															:placeholder="$_signUp_langPhonePlaceholder"
															:prefix="$_signUp_langPhonePrefix"
															:suffix="$_signUp_langPhoneSuffix"
															:type="$_signUp_langPhoneType"

															:label="$_signUp_langPhone" 

															:error-messages="errors" />
												</validation-provider>
											</template>
										</v-card-text>
										<v-card-text class="cardText_">
											<validation-provider
													name="Password"
													rules="required|min:8"
													mode="lazy"
													v-slot="{ errors }">
												<v-text-field
														v-model="form_.password"

														hide-details

														:background-color="$_signUp_styleTextFieldBackgroundColor"
														:clearable="$_signUp_styleTextFieldClearable"
														:color="$_signUp_styleTextFieldColor"
														:counter="$_signUp_styleTextFieldCounter"
														:dark="$_signUp_styleTextFieldDark"
														:filled="$_signUp_styleTextFieldFilled"
														:flat="$_signUp_styleTextFieldFlat"
														:light="$_signUp_styleTextFieldLight"
														:outlined="$_signUp_styleTextFieldOutlined"
														:solo="$_signUp_styleTextFieldSolo"
														:solo-inverted="$_signUp_styleTextFieldSoloInverted"

														:hint="$_signUp_langPasswordHint"
														:mask="$_signUp_langPasswordMask"
														:message="$_signUp_langPasswordMessage"
														:placeholder="$_signUp_langPasswordPlaceholder"
														:prefix="$_signUp_langPasswordPrefix"
														:suffix="$_signUp_langPasswordSuffix"

														:append-icon="showPassword_ ? 'visibility_off' : 'visibility'"
														:type="showPassword_ ? 'text' : 'password'"

														:label="$_signUp_langPassword"

														:error-messages="errors"
														@click:append="showPassword_ = !showPassword_" />
											</validation-provider>
										</v-card-text>
										<v-card-text class="cardText_">
											<validation-provider
													name="confirmPassword"
													rules="required"
													v-slot="{ errors }">
												<v-text-field
														v-model="form_.confirmPassword"

														hide-details

														:background-color="$_signUp_styleTextFieldBackgroundColor"
														:clearable="$_signUp_styleTextFieldClearable"
														:color="$_signUp_styleTextFieldColor"
														:counter="$_signUp_styleTextFieldCounter"
														:dark="$_signUp_styleTextFieldDark"
														:filled="$_signUp_styleTextFieldFilled"
														:flat="$_signUp_styleTextFieldFlat"
														:light="$_signUp_styleTextFieldLight"
														:outlined="$_signUp_styleTextFieldOutlined"
														:solo="$_signUp_styleTextFieldSolo"
														:solo-inverted="$_signUp_styleTextFieldSoloInverted"

														:hint="$_signUp_langConfirmPasswordHint"
														:mask="$_signUp_langConfirmPasswordMask"
														:message="$_signUp_langConfirmPasswordMessage"
														:placeholder="$_signUp_langConfirmPasswordPlaceholder"
														:prefix="$_signUp_langConfirmPasswordPrefix"
														:suffix="$_signUp_langConfirmPasswordSuffix"

														:append-icon="showPassword_ ? 'visibility_off' : 'visibility'"
														:type="showPassword_ ? 'text' : 'password'"

														:label="$_signUp_langConfirmPassword"

														:error-messages="errors"
														@click:append="showPassword_ = !showPassword_" />
											</validation-provider>
										</v-card-text>
										<v-card-actions class="center">
											<v-row class="mb-4" dense justify="center">
												<v-col cols="auto">
													<v-btn	class="customVBtn"

															:disabled="!validationInput.passed && !validationInput.valid"

															:block="$_signUp_styleSignUpButtonBlock"
															:color="$_signUp_styleSignUpButtonColor"
															:dark="!validationInput.passed && !validationInput.valid ? $_signUp_stateAppIsDarkTheme : $_signUp_styleSignUpButtonDark"
															:depressed="$_signUp_styleSignUpButtonDepressed"
															:elevation="$_signUp_styleSignUpButtonElevation"
															:large="$_signUp_styleSignUpButtonLarge"
															:light="$_signUp_styleSignUpButtonLight"
															:outlined="$_signUp_styleSignUpButtonOutlined"
															:rounded="$_signUp_styleSignUpButtonRounded"
															:small="$_signUp_styleSignUpButtonSmall"
															:text="$_signUp_styleSignUpButtonFlat"
															@click="$_signUp_signUp()">
														<template v-if="isFalse(onProgress_)">
															<span v-text="$_signUp_langSignUpButton" />
														</template>
														<template v-else>
															<progress-circular />
														</template>
													</v-btn>
												</v-col>
												<v-col cols="auto">
													<v-btn	class="customVBtn"
															:block="$_signUp_styleCancelButtonBlock"
															:color="$_signUp_styleCancelButtonColor"
															:dark="$_signUp_styleCancelButtonDark"
															:depressed="$_signUp_styleCancelButtonDepressed"
															:elevation="$_signUp_styleCancelButtonElevation"
															:large="$_signUp_styleCancelButtonLarge"
															:light="$_signUp_styleCancelButtonLight"
															:outlined="$_signUp_styleCancelButtonOutlined"
															:rounded="$_signUp_styleCancelButtonRounded"
															:small="$_signUp_styleCancelButtonSmall"
															:text="$_signUp_styleCancelButtonFlat"
															@click="$_signUp_cancel()"
															v-text="$_signUp_langCancelButton" />
												</v-col>
											</v-row>
										</v-card-actions>
									</v-form>
								</validation-observer>
							</template>
							<!-- emailLink (sign up by email) -->
							<template v-if="mode_.emailLink">
								<v-card-text class="cardText_ center">
									<span v-html="$_signUp_langEmailLinkText" />
								</v-card-text>
								<v-card-actions class="center">
									<v-row class="mb-4" dense justify="center">
										<v-col cols="auto">
											<v-btn	class="customVBtn"
													:block="$_signUp_styleOkButtonBlock"
													:color="$_signUp_styleOkButtonColor"
													:dark="$_signUp_styleOkButtonDark"
													:depressed="$_signUp_styleOkButtonDepressed"
													:elevation="$_signUp_styleOkButtonElevation"
													:large="$_signUp_styleOkButtonLarge"
													:light="$_signUp_styleOkButtonLight"
													:outlined="$_signUp_styleOkButtonOutlined"
													:rounded="$_signUp_styleOkButtonRounded"
													:small="$_signUp_styleOkButtonSmall"
													:text="$_signUp_styleOkButtonFlat"
													@click="openLink($_signUp_linkOkButton)"
													v-text="$_signUp_langOkButton" />
										</v-col>
									</v-row>
								</v-card-actions>
							</template>
							<!-- verify otp (sign up by phone) -->
							<template v-if="mode_.otp">
								<validation-observer v-slot="validationOtp">
									<v-form>
										<v-card-text class="cardText_">
											<validation-provider
													name="Otp"
													rules="required|numeric|min:6|max:6"
													v-slot="{ errors }">
												<v-text-field
														v-model="form_.otp"

														hide-details

														:background-color="$_signUp_styleTextFieldBackgroundColor"
														:clearable="$_signUp_styleTextFieldClearable"
														:color="$_signUp_styleTextFieldColor"
														:counter="$_signUp_styleTextFieldCounter"
														:dark="$_signUp_styleTextFieldDark"
														:filled="$_signUp_styleTextFieldFilled"
														:flat="$_signUp_styleTextFieldFlat"
														:light="$_signUp_styleTextFieldLight"
														:outlined="$_signUp_styleTextFieldOutlined"
														:solo="$_signUp_styleTextFieldSolo"
														:solo-inverted="$_signUp_styleTextFieldSoloInverted"

														:hint="$_signUp_langOtpHint"
														:mask="$_signUp_langOtpMask"
														:message="$_signUp_langOtpMessage"
														:placeholder="$_signUp_langOtpPlaceholder"
														:prefix="$_signUp_langOtpPrefix"
														:suffix="$_signUp_langOtpSuffix"
														:type="$_signUp_langOtpType"

														:label="$_signUp_langOtp"

														:error-messages="errors" />
											</validation-provider>
										</v-card-text>
										<v-card-actions class="center">
											<v-row class="mb-4" dense justify="center">
												<v-col cols="auto">
													<v-btn	class="customVBtn"

															:disabled="!validationOtp.passed && !validationOtp.valid"

															:block="$_signUp_styleVerifyButtonBlock"
															:color="$_signUp_styleVerifyButtonColor"
															:dark="!validationOtp.passed && !validationOtp.valid ? $_signUp_stateAppIsDarkTheme : $_signUp_styleVerifyButtonDark"
															:depressed="$_signUp_styleVerifyButtonDepressed"
															:elevation="$_signUp_styleVerifyButtonElevation"
															:large="$_signUp_styleVerifyButtonLarge"
															:light="$_signUp_styleVerifyButtonLight"
															:outlined="$_signUp_styleVerifyButtonOutlined"
															:rounded="$_signUp_styleVerifyButtonRounded"
															:small="$_signUp_styleVerifyButtonSmall"
															:text="$_signUp_styleVerifyButtonFlat"
															@click="$_signUp_verifyOtp()"
															v-text="$_signUp_langVerifyButton" />
												</v-col>
											</v-row>
										</v-card-actions>
									</v-form>
								</validation-observer>
							</template>
						</template>
					</v-card>
				</v-col>
			</v-row>
			<!-- for sending otp -->
			<v-row>
				<v-col id="recaptcha" />
			</v-row>
		</template>
		<template v-else>
			<v-row	class="customVRow">
				<v-col cols="12" class="center">
					<progress-circular />
				</v-col>
			</v-row>
		</template>
	</v-container>
</template>

<script>
	import firebase_ from 'firebase/app';
	import 'firebase/auth';
	
	export default {
		name: 'SignUp',
		data() {
			return {
				pageName_: 'signUp',
				pageType_: 'signUp',

				initialized_: false,

				signUpOption_: '',
				showPassword_: false,
				errorMessage_: null,
				onProgress_: false,

				mode_: {
					signUp: true,
					registered: false,
					emailLink: false,
					otp: false
				},

				form_: {
					email: null,
					phone: null,
					password: null,
					confirmPassword: null,
					otp: null
				}
			}
		},
		computed: {
			// current user
			$_signUp_currentUser() {
				const self_ = this;
				return self_.getCurrentUser()
			},
			// state
			$_signUp_stateAppIsDarkTheme() {
				const self_ = this;
				return self_.getAppState('isDarkTheme')
			},
			$_signUp_statePageIsInitialized() {
				const self_ = this;
				const initialized_ = self_.getPageState('isInitialized')
				return initialized_[self_.pageName_]
			},
			// app sign up options
			$_signUp_contentAppSignUpOptions() {
				const self_ = this;
				const contents_ = self_.getAppContents('signUpOptions')
				return self_.getContentsSubset(contents_, 'isDummy', false)
			},
			// contents / inits
			$_signUp_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getPageContents(self_.pageName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_signUp_inits() {
				const self_ = this;
				return () => {
					return self_.getPageInits(self_.pageName_)
				}
			},
			// info
			$_signUp_infoContact() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.$_signUp_inits(), 'contact')
			},
			// lang
			$_signUp_langLoginButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'loginButton')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langCancelButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'cancelButton')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langConfirmPassword() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'confirmPassword')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langConfirmPasswordHint() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'confirmPasswordHint')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langConfirmPasswordMask() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'confirmPasswordMask')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langConfirmPasswordMessage() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'confirmPasswordMessage')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langConfirmPasswordPlaceholder() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'confirmPasswordPlaceholder')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langConfirmPasswordPrefix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'confirmPasswordPrefix')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langConfirmPasswordSuffix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'confirmPasswordSuffix')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langConfirmPasswordType() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'confirmPasswordType')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langEmail() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'email')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langEmailHint() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'emailHint')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langEmailMask() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'emailMask')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langEmailMessage() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'emailMessage')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langEmailPlaceholder() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'emailPlaceholder')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langEmailPrefix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'emailPrefix')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langEmailSuffix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'emailSuffix')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langEmailType() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'emailType')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langOtp() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'otp')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langOtpHint() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'otpHint')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langOtpMask() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'otpMask')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langOtpMessage() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'otpMessage')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langOtpPlaceholder() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'otpPlaceholder')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langOtpPrefix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'otpPrefix')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langOtpSuffix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'otpSuffix')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langOtpType() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'otpType')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langPassword() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'password')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langPasswordHint() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'passwordHint')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langPasswordMask() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'passwordMask')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langPasswordMessage() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'passwordMessage')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langPasswordPlaceholder() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'passwordPlaceholder')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langPasswordPrefix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'passwordPrefix')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langPasswordSuffix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'passwordSuffix')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langPasswordType() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'passwordType')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langPhone() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'phone')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langPhoneHint() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'phoneHint')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langPhoneMask() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'phoneMask')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langPhoneMessage() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'phoneMessage')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langPhonePlaceholder() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'phonePlaceholder')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langPhonePrefix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'phonePrefix')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langPhoneSuffix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'phoneSuffix')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langPhoneType() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'phoneType')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langSelectSignUpOption() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'selectSignUpOption')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langSelectSignUpOptionHint() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'selectSignUpOptionHint')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langSelectSignUpOptionMask() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'selectSignUpOptionMask')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langSelectSignUpOptionMessage() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'selectSignUpOptionMessage')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langSelectSignUpOptionPlaceholder() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'selectSignUpOptionPlaceholder')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langSelectSignUpOptionPrefix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'selectSignUpOptionPrefix')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langSelectSignUpOptionSuffix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'selectSignUpOptionSuffix')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langSelectSignUpOptionType() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'selectSignUpOptionType')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langSignUpButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'signUpButton')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langVerifyButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'verifyButton')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langRegisteredText() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'registeredText')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langEmailLinkText() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'emailLinkText')
				return self_.getLangsVal(lang_)
			},
			$_signUp_langOkButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_signUp_inits(), 'okButton')
				return self_.getLangsVal(lang_)
			},
			// link
			$_signUp_linkVerifyButton() {
				const self_ = this;
				return self_.getInitsLinkVal(self_.$_signUp_inits(), 'verifyButton')
			},
			$_signUp_linkOkButton() {
				const self_ = this;
				return self_.getInitsLinkVal(self_.$_signUp_inits(), 'okButton')
			},
			// style
			$_signUp_stylePageContainer() {
				const self_ = this;
				if(self_.isEmpty(self_.$_signUp_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_signUp_inits(), 'pageContainer')
			},
			$_signUp_stylePageContainerStyle() {
				const self_ = this;
				return () => {
					const page_ = self_.$_signUp_stylePageContainer;
					if(self_.isFalse(page_)) { return null }
					return self_.getStylesVal(page_.style)
				}
			},
			$_signUp_styleSelect() {
				const self_ = this;
				if(self_.isEmpty(self_.$_signUp_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_signUp_inits(), 'select')
			},
			$_signUp_styleSelectBackgroundColor() {
				const self_ = this;
				const select_ = self_.$_signUp_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.color)
			},
			$_signUp_styleSelectChips() {
				const self_ = this;
				const select_ = self_.$_signUp_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.chips)
			},
			$_signUp_styleSelectClearable() {
				const self_ = this;
				const select_ = self_.$_signUp_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.clearable)
			},
			$_signUp_styleSelectColor() {
				const self_ = this;
				const select_ = self_.$_signUp_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.color)
			},
			$_signUp_styleSelectDeletableChips() {
				const self_ = this;
				const select_ = self_.$_signUp_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.deletableChips)
			},
			$_signUp_styleSelectDark() {
				const self_ = this;
				const select_ = self_.$_signUp_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.dark)
			},
			$_signUp_styleSelectDense() {
				const self_ = this;
				const select_ = self_.$_signUp_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.dense)
			},
			$_signUp_styleSelectFilled() {
				const self_ = this;
				const select_ = self_.$_signUp_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.filled)
			},
			$_signUp_styleSelectFlat() {
				const self_ = this;
				const select_ = self_.$_signUp_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.flat)
			},
			$_signUp_styleSelectLight() {
				const self_ = this;
				const select_ = self_.$_signUp_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.light)
			},
			$_signUp_styleSelectOutlined() {
				const self_ = this;
				const select_ = self_.$_signUp_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.outlined)
			},
			$_signUp_styleSelectSmallChips() {
				const self_ = this;
				const select_ = self_.$_signUp_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.smallChips)
			},
			$_signUp_styleSelectSolo() {
				const self_ = this;
				const select_ = self_.$_signUp_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.solo)
			},
			$_signUp_styleSelectSoloInverted() {
				const self_ = this;
				const select_ = self_.$_signUp_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.soloInverted)
			},
			$_signUp_styleTextField() {
				const self_ = this;
				if(self_.isEmpty(self_.$_signUp_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_signUp_inits(), 'textField')
			},
			$_signUp_styleTextFieldBackgroundColor() {
				const self_ = this;
				const style_ = self_.$_signUp_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.backgroundColor)
			},
			$_signUp_styleTextFieldClearable() {
				const self_ = this;
				const style_ = self_.$_signUp_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.clearable)
			},
			$_signUp_styleTextFieldColor() {
				const self_ = this;
				const style_ = self_.$_signUp_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.color)
			},
			$_signUp_styleTextFieldCounter() {
				const self_ = this;
				const style_ = self_.$_signUp_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.counter)
			},
			$_signUp_styleTextFieldDark() {
				const self_ = this;
				const style_ = self_.$_signUp_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dark)
			},
			$_signUp_styleTextFieldFilled() {
				const self_ = this;
				const style_ = self_.$_signUp_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.filled)
			},
			$_signUp_styleTextFieldFlat() {
				const self_ = this;
				const style_ = self_.$_signUp_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.flat)
			},
			$_signUp_styleTextFieldLight() {
				const self_ = this;
				const style_ = self_.$_signUp_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.light)
			},
			$_signUp_styleTextFieldOutlined() {
				const self_ = this;
				const style_ = self_.$_signUp_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.outlined)
			},
			$_signUp_styleTextFieldSolo() {
				const self_ = this;
				const style_ = self_.$_signUp_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.solo)
			},
			$_signUp_styleTextFieldSoloInverted() {
				const self_ = this;
				const style_ = self_.$_signUp_styleTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.soloInverted)
			},
			$_signUp_styleLoginButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_signUp_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_signUp_inits(), 'loginButton')
			},
			$_signUp_styleLoginButtonBlock() {
				const self_ = this;
				const button_ = self_.$_signUp_styleLoginButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_signUp_styleLoginButtonColor() {
				const self_ = this;
				const button_ = self_.$_signUp_styleLoginButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_signUp_styleLoginButtonDark() {
				const self_ = this;
				const button_ = self_.$_signUp_styleLoginButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_signUp_styleLoginButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_signUp_styleLoginButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_signUp_styleLoginButtonElevation() {
				const self_ = this;
				const button_ = self_.$_signUp_styleLoginButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_signUp_styleLoginButtonFlat() {
				const self_ = this;
				const button_ = self_.$_signUp_styleLoginButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_signUp_styleLoginButtonLarge() {
				const self_ = this;
				const button_ = self_.$_signUp_styleLoginButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_signUp_styleLoginButtonLight() {
				const self_ = this;
				const button_ = self_.$_signUp_styleLoginButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_signUp_styleLoginButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_signUp_styleLoginButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_signUp_styleLoginButtonRounded() {
				const self_ = this;
				const button_ = self_.$_signUp_styleLoginButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_signUp_styleLoginButtonSmall() {
				const self_ = this;
				const button_ = self_.$_signUp_styleLoginButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_signUp_styleSignUpButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_signUp_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_signUp_inits(), 'signUpButton')
			},
			$_signUp_styleSignUpButtonBlock() {
				const self_ = this;
				const button_ = self_.$_signUp_styleSignUpButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_signUp_styleSignUpButtonColor() {
				const self_ = this;
				const button_ = self_.$_signUp_styleSignUpButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_signUp_styleSignUpButtonDark() {
				const self_ = this;
				const button_ = self_.$_signUp_styleSignUpButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_signUp_styleSignUpButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_signUp_styleSignUpButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_signUp_styleSignUpButtonElevation() {
				const self_ = this;
				const button_ = self_.$_signUp_styleSignUpButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_signUp_styleSignUpButtonFlat() {
				const self_ = this;
				const button_ = self_.$_signUp_styleSignUpButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_signUp_styleSignUpButtonLarge() {
				const self_ = this;
				const button_ = self_.$_signUp_styleSignUpButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_signUp_styleSignUpButtonLight() {
				const self_ = this;
				const button_ = self_.$_signUp_styleSignUpButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_signUp_styleSignUpButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_signUp_styleSignUpButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_signUp_styleSignUpButtonRounded() {
				const self_ = this;
				const button_ = self_.$_signUp_styleSignUpButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_signUp_styleSignUpButtonSmall() {
				const self_ = this;
				const button_ = self_.$_signUp_styleSignUpButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_signUp_styleCancelButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_signUp_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_signUp_inits(), 'cancelButton')
			},
			$_signUp_styleCancelButtonBlock() {
				const self_ = this;
				const button_ = self_.$_signUp_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_signUp_styleCancelButtonColor() {
				const self_ = this;
				const button_ = self_.$_signUp_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_signUp_styleCancelButtonDark() {
				const self_ = this;
				const button_ = self_.$_signUp_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_signUp_styleCancelButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_signUp_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_signUp_styleCancelButtonElevation() {
				const self_ = this;
				const button_ = self_.$_signUp_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_signUp_styleCancelButtonFlat() {
				const self_ = this;
				const button_ = self_.$_signUp_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_signUp_styleCancelButtonLarge() {
				const self_ = this;
				const button_ = self_.$_signUp_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_signUp_styleCancelButtonLight() {
				const self_ = this;
				const button_ = self_.$_signUp_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_signUp_styleCancelButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_signUp_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_signUp_styleCancelButtonRounded() {
				const self_ = this;
				const button_ = self_.$_signUp_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_signUp_styleCancelButtonSmall() {
				const self_ = this;
				const button_ = self_.$_signUp_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_signUp_styleVerifyButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_signUp_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_signUp_inits(), 'verifyButton')
			},
			$_signUp_styleVerifyButtonBlock() {
				const self_ = this;
				const button_ = self_.$_signUp_styleVerifyButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_signUp_styleVerifyButtonColor() {
				const self_ = this;
				const button_ = self_.$_signUp_styleVerifyButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_signUp_styleVerifyButtonDark() {
				const self_ = this;
				const button_ = self_.$_signUp_styleVerifyButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_signUp_styleVerifyButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_signUp_styleVerifyButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_signUp_styleVerifyButtonElevation() {
				const self_ = this;
				const button_ = self_.$_signUp_styleVerifyButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_signUp_styleVerifyButtonFlat() {
				const self_ = this;
				const button_ = self_.$_signUp_styleVerifyButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_signUp_styleVerifyButtonLarge() {
				const self_ = this;
				const button_ = self_.$_signUp_styleVerifyButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_signUp_styleVerifyButtonLight() {
				const self_ = this;
				const button_ = self_.$_signUp_styleVerifyButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_signUp_styleVerifyButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_signUp_styleVerifyButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_signUp_styleVerifyButtonRounded() {
				const self_ = this;
				const button_ = self_.$_signUp_styleVerifyButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_signUp_styleVerifyButtonSmall() {
				const self_ = this;
				const button_ = self_.$_signUp_styleVerifyButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_signUp_styleOkButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_signUp_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_signUp_inits(), 'okButton')
			},
			$_signUp_styleOkButtonBlock() {
				const self_ = this;
				const button_ = self_.$_signUp_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_signUp_styleOkButtonColor() {
				const self_ = this;
				const button_ = self_.$_signUp_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_signUp_styleOkButtonDark() {
				const self_ = this;
				const button_ = self_.$_signUp_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_signUp_styleOkButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_signUp_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_signUp_styleOkButtonElevation() {
				const self_ = this;
				const button_ = self_.$_signUp_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_signUp_styleOkButtonFlat() {
				const self_ = this;
				const button_ = self_.$_signUp_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_signUp_styleOkButtonLarge() {
				const self_ = this;
				const button_ = self_.$_signUp_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_signUp_styleOkButtonLight() {
				const self_ = this;
				const button_ = self_.$_signUp_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_signUp_styleOkButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_signUp_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_signUp_styleOkButtonRounded() {
				const self_ = this;
				const button_ = self_.$_signUp_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_signUp_styleOkButtonSmall() {
				const self_ = this;
				const button_ = self_.$_signUp_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			}
		},
		created() {
			const self_ = this;
			// life cycle
			self_.createdPage(self_.pageName_)

			self_.$_signUp_setPageState()

			if(self_.$_signUp_statePageIsInitialized) { 
				self_.initialized_ = true;
			} else {
				self_.$_signUp_initialize()
			}
		},
		beforeMount() {
			const self_ = this;
			self_.beforeMountPage(self_.pageName_)
		},
		beforeDestroy() {
			const self_ = this;
			self_.beforeDestroyPage(self_.pageName_)
		},
		methods: {
			$_signUp_setPageState() {
				const self_ = this;

				self_.setPageState('name', self_.pageName_)
				self_.setPageState('type', self_.pageType_)
			},
			$_signUp_initialize() {
				const self_ = this;

				Promise.resolve().then(() => {
					return self_.initializePage(self_.pageName_, self_.pageType_)
				}).then(() => {
					self_.initialized_ = true;
				}).catch(error => {
/* error */			self_.logError('Error', '$_signUp_initialize()', error)
				})
			},
			$_signUp_signUp() {
				const self_ = this;

				if(self_.form_.password != self_.form_.confirmPassword) {
					self_.errorMessage_ = 'Password does not match.';
					return
				}

				self_.onProgress_ = true;

				Promise.resolve().then(() => {
					if(self_.signUpOption_ == 'email') { return self_.$_signUp_signUpByEmail() }
					if(self_.signUpOption_ == 'phone') { return self_.$_signUp_signUpByPhone() }
				}).then(() => {
					if(self_.signUpOption_ == 'email') { return self_.mode_ = { emailLink: true } }
					if(self_.signUpOption_ == 'phone') { return self_.mode_ = { otp: true } }
					self_.onProgress_ = false;
				}).catch(error => {
					self_.errorMessage_ = error;
					self_.onProgress_ = false;
/* error */			self_.logError('Error', '$_signUp_signUp()', error)
				})
			},
			$_signUp_signUpByEmail() {
				const self_ = this;

				window.localStorage.setItem('modeOfAuth', 'signUp')
				window.localStorage.setItem('emailForAuth', self_.form_.email)
				window.localStorage.setItem('passwordForAuth', self_.form_.password)

				return self_.sendEmailLink()
			},
			$_signUp_signUpByPhone() {
				const self_ = this;

				let phone_ = null;

				if(self_.form_.phone.substr(0, 4) == 'test') {
					phone_ = '+1650555' + self_.form_.phone.substr(4, 4);
				} else if(self_.form_.phone == 'admin') {
					phone_ = '+16505550000';
				} else {
					phone_ = '+628' + self_.form_.phone;
				}

				return self_.sendOtp(phone_)
			},
			$_signUp_verifyOtp(){
				const self_ = this;
				const router_ = self_.$router;

				const otp_ = self_.form_.otp;
				
				let email_ = null;
				if(self_.form_.phone.substr(0, 4) == 'test' || self_.form_.phone == 'admin') {
					email_ = 'boid.dev.app+' + self_.appId + '-' + self_.form_.phone + '@gmail.com'
				} else {
					email_ = 'boid.dev.app+' + self_.appId + '-08' + self_.form_.phone + '@gmail.com'
				}
				let phone_ = null;
				if(self_.form_.phone.substr(0, 4) == 'test') {
					phone_ = '+1650555' + self_.form_.phone.substr(4, 4);
				} else if(self_.form_.phone == 'admin') {
					phone_ = '+16505550000';
				} else {
					phone_ = '08' + self_.form_.phone;
				}
				let username_ = null;
				if(self_.form_.phone.substr(0, 4) == 'test' || self_.form_.phone == 'admin') {
					username_ = self_.form_.phone
				} else {
					username_ = '08' + self_.form_.phone;
				}
				const password_ = self_.form_.password;

				let uid_ = null;

				Promise.resolve().then(() => {
					return self_.verifyOtp(otp_)
				}).then(result => {
					uid_ = result.user.uid;

					const credential_ = firebase_.auth.EmailAuthProvider.credential(email_, password_)
					return self_.firebase.auth().currentUser.linkWithCredential(credential_)
				}).then(() => {
					return self_.ipCliStoreAppUsers(uid_, username_, username_, email_, phone_, null, null, null, null, 'all', 'All Users', 'anonymous', 'Anonymous', false, false, null)
				}).then(() => {
					return self_.ipcRegisterUser(username_, uid_, email_, phone_, phone_) // full name = phone number
				}).then(() => {
					setTimeout(() => { router_.replace('/') }, 1000)
				}).catch(error => {
/* error */			self_.logError('Error', '$_signUp_verifyOtp()', error)
				})
			},
			$_signUp_cancel(){
				const self_ = this;
				
				self_.signUpOption_ = '';

				self_.mode_ = {
					signUp: true,
					otp: false
				}
			}
		}
	}
</script>

<style scoped>
	.errorMessage_ {
		color: red;
	}
	.cardText_ {
		padding-top: 0 !important;
	}
</style>